import alt from "../alt";
import si from "si";

class CreateAccountActions {
	submitAccount(sendData) {

		si.enrollCustomerWithAddress(sendData).then(success => {
			this.enrollSuccess(success);
		}, this.enrollFailure);
		return true;
	}

	enrollSuccess(success) {
		return success;
	}

	enrollFailure(data) {
		let errorResponse = JSON.parse(JSON.parse(data.responseText));
		console.log(errorResponse);
		return errorResponse;
	}
}

export default alt.createActions(CreateAccountActions);



// WEBPACK FOOTER //
// ./../../Deploy/PWS/ViewModels/Components/GuestCheckout/CreateAccountActions.js